import { action } from '@ember/object';
import Component from '@glimmer/component';

export default class InitiativesDocumentVersionsSlideoverComponent extends Component {
  get isOpen() {
    return this.args.isOpen;
  }

  @action
  onRender(element) {
    this.element = element;
  }

  @action
  closeSlideover() {
    this.args.closeSlideover();
  }

  @action
  onClick() {}

  @action
  revertToCurrentVersion() {
    this.args?.restoreToCurrentVersion?.();
  }

  @action
  handleVersionItemClick(version) {
    this.args?.onVersionItemClick?.(version);
  }
}
